import {
	LOGIN_TOKEN_KEY
} from '@/config/cache'
import Cache from '@/utils/cache'
const router = {

	// 上一页页面地址
	prev_page() {
		var value = null;
		var pages = uni.$u.pages()
		var length = pages.length;
		if (length > 1) {
			value = this.page_url_handle(pages[length - 2]);
		}
		return value;
	},
	// 返回上一页、则回到shouy，没有页面的时候url是否指定页面
	page_back_prev_event(url = null) {
		var prev_page = router.prev_page();
		if (prev_page == null) {
			if (url) {
				router.goPage(url)
			} else {
				uni.$u.route({
					url: url || '/pages/home/home',
					type: 'tab'
				})
			}
		} else {
			uni.navigateBack();
		}
	},

	// 页面地址处理
	page_url_handle(page) {
		if ((page || null) == null) {
			return '';
		}

		// 直接获取页面全的路径地址
		if ((page.$page || null) != null && (page.$page.fullPath || null) != null) {
			var path = page.$page.fullPath;
			return path.substr(0, 1) == '/' ? path.substr(1) : path;
		}

		// 拼接地址和参数
		var route = page.route;
		var options = page.options || {};
		var query = '';
		if (JSON.stringify(options) != '{}') {
			for (var i in options) {
				query += '&' + i + '=' + options[i];
			}
		}
		if ((query || null) != null) {
			route += '?' + query.substr(1);
		}
		return route;
	},
	goPageNoLogin(page, params = {}) {
		if (!params) params = {}
		uni.$u.route({
			url: page,
			params,
			// #ifdef MP
			type: uni.$u.pages().length >= 10 ? 'redirectTo' : 'navigateTo'
			// #endif
		})
	},
	goPage(page, params = {}) {
		if (!params) params = {}
		// if (page === '/pages/desc/desc') {
		// 	uni.$u.route({
		// 		url: page,
		// 		params
		// 	})
		// 	return
		// }

		if (Cache.get(LOGIN_TOKEN_KEY)) {
			uni.$u.route({
				url: page,
				params,
				// #ifdef MP
				type: uni.$u.pages().length >= 10 ? 'redirectTo' : 'navigateTo'
				// #endif
			})
		} else {
			uni.$xc.modal('此功能需要登录后才能继续操作', '', (c) => {
				if (c) {
					uni.$u.route({
						url: '/pages/login/login',
						params,
						// #ifdef MP
						type: uni.$u.pages().length >= 10 ? 'redirectTo' : 'navigateTo'
						// #endif
					})
				}
			}, '前往', true)
		}
	},
	openRoute(row) {
		console.log('我进来啊', row)
		if (row.path.includes('pages/contacts/contacts')) {
			row.path = row.path.replace("pages/", "pagesA/");
		}
		if (row.path.includes('pages/help/help')) {
			row.path = row.path.replace("pages/", "pagesA/");
		}
		if (row.path.includes('pages/diary/index')) {
			row.path = row.path.replace("pages/", "pagesA/");
		}
		if (row.path.includes('pages/my/stampRecord')) {
			row.path = row.path.replace("pages/", "pagesA/");
		}
		if (row.path.includes('pages/ext/collect/collect')) {
			row.path = row.path.replace("pages/", "pagesA/");
		}
		if (row.path.includes('pages/my/recharge/recharge')) {
			row.path = row.path.replace("pages/", "pagesA/");
		}
		if (row.path.includes('pages/my/coupon')) {
			row.path = row.path.replace("pages/", "pagesA/");
		}
		if (row.path.includes('pages/my/about')) {
			row.path = row.path.replace("pages/", "pagesA/");
		}

		if (row && row.path.length > 0) {
			switch (row.openType) {
				case 0:
					//内部页面WEB
					if (row.isLogin) {
						return router.goPage('/pages/web/web', {
							url: row.params.url,
							title: (row.params.title ? row.title : '网页')
						})
					}
					uni.$u.route({
						url: '/pages/web/web',
						params: {
							url: row.params.url,
							title: (row.params.title ? row.params.title : '网页')
						}
					})
					return
				case 1:
					//外部页面
					plus.runtime.openURL(row.path, function(res) {
						console.log(res);
					})
					return
				case 2:
					//内部页面
					if (row.isLogin) {
						return router.goPage(row.path, row.params)
					}
					uni.$u.route({
						url: row.path,
						params: row.params
					})
					return
				case 3:
					//内部页面TAB
					uni.$u.route({
						url: row.path,
						type: 'tab'
					})
					return
					//#ifdef APP-PLUS
				case 4:
					//APP打开微信小程序
					if (row.appid) {
						plus.share.getServices(function(res) {
							try {
								let openWeiXin = res.find(i => i.id === 'weixin')
								openWeiXin.launchMiniProgram({
									id: row.appid,
									path: row.path
								})
							} catch (err) {
								uni.$xc.modal('打开失败，原因:' + JSON.stringify(err))
							}
						}, function(e) {
							uni.$xc.modal('打开失败' + JSON.stringify(e))
						})
						return
					}
					uni.$xc.toast('打开失败，可能是版本过低导致，请更新重试')
					return
					//#endif
					//#ifdef MP
				case 5:
					//小程序跳转小程序
					uni.navigateToMiniProgram({
						appId: row.appid,
						path: (row.path ? row.path : '/pages/index/index'),
						extraData: row.params
					})
					return
					//#endif
				default:
					// uni.$xc.toast('当前类型暂不支持打开')
					return
			}
		}
		uni.$xc.toast('当前类型是展示图，无打开界面')
	}
}
export default router